module.exports = __webpack_public_path__ + "static/media/money-bags.89086c11.png";